import { logWithOffset } from "../../logWithOffset";
let settings = null;

const setup = async (s) => {
  logWithOffset("Initializing Server Events");
  settings = s;
};

const fire = async (e) => {
  if (e.no_server !== true) {
    settings.apiClient.sendEvent(e);
  }
};

export default { setup, fire };
